import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import {FormGroup} from '@material-ui/core';
import ReactSelect from 'react-select';
import {isEmpty} from 'lodash/lang';
import {Edit as EditIcon, Delete as DeleteIcon} from '@material-ui/icons';
import {withKluwellTableWrapper, KluwellTableCore, SortingManager, DeletionConfirmBox} from 'components/common';
import {formatTipType, levelMap, tipTypeOptions, levelOptions} from 'utils/common';

class ExtraFilters extends React.Component {
  static propTypes = {
    onChange: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.handleTypeChange = this.handleTypeChange.bind(this);
    this.handleLevelChange = this.handleLevelChange.bind(this);
  }

  handleTypeChange(selected) {
    const {onChange} = this.props;
    onChange({
      name: 'type',
      value: selected ? selected.value : undefined,
    });
  }

  handleLevelChange(selected) {
    const {onChange} = this.props;
    onChange({
      name: 'level',
      value: selected ? selected.value : undefined,
    });
  }

  render() {
    const {
      values: {type, level},
    } = this.props;
    return (
      <div className="extra-table-filters">
        <FormGroup>
          <ReactSelect
            name="type"
            value={type}
            placeholder="Type"
            onChange={this.handleTypeChange}
            options={tipTypeOptions}
            autoBlur={true}
            closeOnSelect={true}
          />
        </FormGroup>
        <FormGroup>
          <ReactSelect
            name="level"
            value={level}
            placeholder="App Level"
            onChange={this.handleLevelChange}
            options={levelOptions}
            autoBlur={true}
            closeOnSelect={true}
          />
        </FormGroup>
      </div>
    );
  }
}

const buildTipRecords = (tips) => {
  const sortedIds = tips.sortedIds || [];
  return isEmpty(sortedIds)
    ? []
    : sortedIds.map((tipId) => {
        const tip = tips[tipId];
        return {
          record: tip,
          id: tipId,
          title: tip.title,
          body: tip.body,
          type: formatTipType(tip.type),
          level: levelMap[tip.level] || 'All Level',
          actions: '',
        };
      });
};

const buildTipSettings = () => ({
  title: {
    fieldText: 'Title',
  },
  body: {
    fieldText: 'Body',
  },
  type: {
    fieldText: 'Type',
    formatData: (cell) => <span className="text-capitalize">{cell}</span>,
  },
  level: {
    fieldText: 'App Level',
    formatData: (cell) => <span className="text-capitalize">{cell}</span>,
  },
  actions: {
    fieldText: 'Actions',
    formatData: (cell, row, restProps) => (
      <span className="table-actions">
        <EditIcon className="cursor-pointer" onClick={() => restProps.showUpdateModal(row.record)} />
        {restProps.canDeleteRow && (
          <DeleteIcon className="cursor-pointer" onClick={() => restProps.showDeletionConfirmBox(row)} />
        )}
      </span>
    ),
  },
});

class TipTableCore extends React.Component {
  static propTypes = {
    recordPages: PropTypes.object.isRequired,
    onSortableFieldClick: PropTypes.func.isRequired,
    onDeleteActionClick: PropTypes.func,
    showUpdateModal: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      tipToRemove: {},
    };
    this.showDeletionConfirmBox = this.showDeletionConfirmBox.bind(this);
    this.sortingManager = new SortingManager();
  }

  showDeletionConfirmBox(tip) {
    this.setState(
      {
        tipToRemove: tip,
      },
      () => {
        ReactDOM.findDOMNode(this.deletionConfirmBoxRef)
          .querySelector('.btn-show-confirm')
          .click();
      },
    );
  }

  render() {
    const {recordPages, onSortableFieldClick, onDeleteActionClick, hiddenFields, showUpdateModal} = this.props;
    const tips = recordPages[recordPages.currentPage] || {};
    const records = buildTipRecords(tips);
    const settings = buildTipSettings();
    return [
      onDeleteActionClick && (
        <DeletionConfirmBox
          key="DeletionConfirmBox"
          ref={(ref) => (this.deletionConfirmBoxRef = ref)}
          itemName="tip"
          deleteAction={() => onDeleteActionClick(this.state.tipToRemove)}
          DeleteButton="span"
        />
      ),
      <KluwellTableCore
        {...{
          key: 'KluwellTableCore',
          records,
          settings,
          sortingManager: this.sortingManager,
          onSortableFieldClick,
          hiddenFields,
          canDeleteRow: !!onDeleteActionClick,
          showDeletionConfirmBox: this.showDeletionConfirmBox,
          showUpdateModal,
        }}
      />,
    ];
  }
}

export default withKluwellTableWrapper(TipTableCore, ExtraFilters);
